module.exports = __webpack_public_path__ + "static/media/local_bank_transfer_logo.49cd9411.svg";